<template>
    <div class="attr">
        <strong class="settingTitle">设置</strong>
        <!-- <el-collapse v-model="activeNames">
            <el-collapse-item name="1">
                <template slot="title">
                    <strong>定义指标</strong>
                </template>
                <bindIndicator />
            </el-collapse-item>
            <el-collapse-item name="2">
                <template slot="title">
                    <strong>输入内容类型</strong>
                </template>
                <inputContentType :currentActiveCell="currentActiveCell" />
            </el-collapse-item>
            <el-collapse-item v-if="currentActiveCell && currentActiveCell.cell_area_type != 'calcArea' && currentActiveCell.cell_area_type != 'quote'"  name="3">
                <template slot="title">
                    <strong>输入方式</strong>
                </template>
                <inputType :currentActiveCell="currentActiveCell" />
            </el-collapse-item>
            <el-collapse-item v-if="currentActiveCell && currentActiveCell.cell_area_type == 'calcArea' && currentActiveCell.cell_area_type != 'quote'" name="4">
                <template slot="title">
                    <strong>参与计算的指标</strong>
                </template>
                <joinIndr :currentActiveCell="currentActiveCell" :joinedIndrs="joinedIndrs" />
            </el-collapse-item>
            <el-collapse-item v-if="currentActiveCell && currentActiveCell.cell_area_type == 'calcArea' && currentActiveCell.cell_area_type != 'quote'" name="5">
                <template slot="title">
                    <strong>设置计算公式</strong>
                </template>
                <setCalc :currentActiveCell="currentActiveCell" />
            </el-collapse-item>
        </el-collapse> -->
        <el-form :model="cellAttrSetModel" label-width="100px" ref="attrSetForm" class="demo-form-inline">
            <el-col>
                <el-form-item label="列对应字段名">
                    <!-- <el-input placeholder="请输入内容" v-model="cellAttrSetModel.cell_prop"></el-input> -->
                    <el-select v-model="cellAttrSetModel.cell_prop" placeholder='请选择字段' filterable clearable>
                        <el-option v-for="item in selectOptions" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col>
              <el-form-item label="转译内容">
                <el-input placeholder="请输入内容" v-model="cellAttrSetModel.cell_resKey"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24" class="ec-operate ec-tARight">
                <el-button type="primary" @click="saveAttr">保存</el-button>
            </el-col>
        </el-form>
    </div>
</template>
<script>
export default {
    props:{
        currentActiveCell:{type:Object,default(){
            return {};
        }},
        reportUrl:{type:String}
    },
    data(){
        return {
            cellAttrSetModel:{},
            activeNames:['3','5','1'],
            joinedIndrs:[],
            selectOptions:[]
        }
    },
    // components:{bindIndicator,inputType,inputContentType,joinIndr,setCalc},
    methods:{
        saveAttr:function() {
            this.$emit('updateAttrSet',this.cellAttrSetModel);
        },
        async getFieldList(value){
            let _this =  this;
            let dynaSeg = { value };
            const { success, message, data } = await _this.Api['getFieldList'](dynaSeg);
            // console.info(data);
            if(success){
                let _data = [];
                for (let i = 0; i < data.total; i++) {
                    _data[i] = [];
                    _data[i].label = data.list[i].label; //将调用方定义的下拉菜单label字段取出，放入组件label中
                    _data[i].value = data.list[i].value; //将调用方定义的下拉菜单value字段取出，放入组件value中
                }
                _this.selectOptions = _data;
            }
        }
    },
    watch: {
        //判断下拉框的值是否有改变
        currentActiveCell: function(newValue, oldValue) {
            this.cellAttrSetModel = newValue;
        },
        reportUrl: function(value) {
            let _this = this;
            _this.getFieldList(value);
        }
    }
}
</script>
<style lang="less" scoped>
    .attr{
        padding: 20px;
        .settingTitle{
            color:#409EFF;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/report/components/design/attrSet.vue